










































































































































































































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'

import TreatmentMixin from '@/views/treatment/TreatmentMixin'

export default mixins(TreatmentMixin).extend({
  computed: {
    isTesterAccount(): boolean {
      return !!this.$store.getters.currentUser!.is_tester_account
    },
  },
  data() {
    const inTwoDays = new Date()
    inTwoDays.setDate(inTwoDays.getDate() + 2)
    return {
      nextSessionStartInDays: inTwoDays,
    }
  },
  props: {
    letter: {
      type: Number,
      required: true,
    },
  },
})
